import { oasys } from '@0xtorch/core'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'
import { geekVerse } from '../viemChains/geekVerse'

export const createGeekVerseChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}) =>
  createGeekVerseChainCustom({
    client: createClient({
      chain: geekVerse,
      httpRpcs: geekVerseHttpRpcs,
    }),
    explorer: createBlockscout({
      name: 'GeekVerse-Mainnet explorer',
      baseUrl: 'https://explorer.geekout-pte.com',
      apiBaseUrl: 'https://explorer.geekout-pte.com/api',
      proxyUrl,
    }),
  })

type CreateGeekVerseChainParameters = {
  client: Client
  explorer: Explorer
}

export const createGeekVerseChainCustom = ({
  client,
  explorer,
}: CreateGeekVerseChainParameters): Chain => ({
  id: 75512,
  network: 'geek-verse',
  name: 'GEEK Verse',
  nativeToken: {
    name: 'Oasys',
    symbol: 'OAS',
    decimals: 18,
    currency: oasys,
  },
  wrappedTokenAddresses: new Set([]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: undefined,
  defillamaId: undefined,
})

export const geekVerseHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.geekout-pte.com',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
]

export const geekVerseWebsocketRpcUrls: readonly string[] = []
